import React from 'react';
import { useCommentLayoutContext } from '../../../../CommentLayoutProvider';
import EmptyThread from './EmptyThread';
import ThreadTemplate from './ThreadTemplate';

export default function ThreadTemplatePicker() {
  const { threadResource } = useCommentLayoutContext();

  if (!threadResource) {
    return (
      <EmptyThread />
    );
  }

  return (
    <ThreadTemplate />
  );
}
